import api from "../../api";
import api3 from "../../api3";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  userProfile({ commit, rootState, rootGetters }) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `profiles/${rootState.user.id}`,
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization: rootGetters.authToken
        }
      })
        .then(resp => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch(err => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  getWallet({ commit, rootGetters }) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `wallets`,
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization: rootGetters.authToken
        }
      })
        .then(resp => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch(err => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  updateProfile({ commit, rootState, rootGetters }, user) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `profiles/${rootState.user.id}`,
        method: "PUT",
        withCredentials: true,
        data: user.data,
        headers: {
          Authorization: rootGetters.authToken
        }
      })
        .then(resp => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch(err => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  browseTalent({ commit, rootGetters }, param) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `talents/profiles/search`,
        method: "POST",
        withCredentials: true,
        data: param,
        headers: {
          Authorization: rootGetters.authToken
        }
      })
        .then(resp => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch(err => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },


  saveTalent({ commit, rootGetters }, param) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `talents/${param.talentId}/save?status=1`,
        method: "POST",
        withCredentials: true,
        data: param,
        headers: {
          Authorization: rootGetters.authToken
        }
      })
        .then(resp => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch(err => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },


  verifyPayment({ commit, rootGetters }, param) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `payments/verify`,
        method: "POST",
        withCredentials: true,
        data: param,
        headers: {
          Authorization: rootGetters.authToken
        }
      })
        .then(resp => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch(err => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  recommendTalent({ commit, rootGetters }, projectId) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `projects/${projectId}/recommend`,
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization: rootGetters.authToken
        }
      })
        .then(resp => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch(err => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  getTalentProfile({ commit, rootGetters }, data) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `talents/profiles/${data.userID}`,
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization: rootGetters.authToken
        }
      })
        .then(resp => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch(err => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  getExchangeRate({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api3({
        url: `currency/convert?format=json&from=${data.respCurrency}&to=USD&amount=1`,
        method: "GET",
        withCredentials: false,
        headers: {
          "x-rapidapi-key": "e68866d3cdmshcf3c4127d688b38p1b0a9fjsn8deb07a200fb",
          "x-rapidapi-host": "currency-converter5.p.rapidapi.com",
          "useQueryString": "true"
        }
      })
        .then(resp => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch(err => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  getClientProfile({ commit, rootGetters }, data) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `clients/profiles/${data.clientID}`,
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization: rootGetters.authToken
        }
      })
        .then(resp => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch(err => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  }


};

export const profiles = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
